import { useEffect, useRef } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import useApiActions from "../../../recoil/api";
import {
  deviceListState,
  isSettingModalOpenState,
  selectedDeviceState,
} from "../../../recoil/record";
import Select from "../../atoms/input/Select";
import Modal from "../layout/Modal";

const DeviceSelectModal = () => {
  const [isSettingModalOpen, setIsSettingModalOpen] = useRecoilState(
    isSettingModalOpenState
  );
  const deviceList = useRecoilValue(deviceListState);
  const [selectedDevice, setSelectedDevice] =
    useRecoilState(selectedDeviceState);
  const audioRef = useRef(null);

  return (
    <Modal isOpen={isSettingModalOpen}>
      <div className="confirm-blur">
        <div className="confirm-content test2-setting">
          <div className="confirm-top flex">
            <div>
              <p className="confirm-top-title">카메라/마이크 설정</p>
            </div>
            <div
              className="close-btn2"
              onClick={() => {
                // console.log("모달다기 div")
                setIsSettingModalOpen(false);
              }}
            >
              <button
                type="button"
                onClick={() => {
                  // console.log("모달닫기");
                  setIsSettingModalOpen(false);
                }}
              ></button>
            </div>
          </div>
          <div className="confirm-sec">
            <div className="camera-select">
              <p className="select-title camera-title">카메라 장치 선택</p>
              <Select
                value={
                  deviceList?.filter((device) => {
                    return (
                      device.deviceId === selectedDevice.video?.deviceId &&
                      device.kind === "videoinput"
                    );
                  }).length !== 0
                    ? selectedDevice.video.deviceId
                    : ""
                }
                onChange={(e) =>
                  setSelectedDevice({
                    ...selectedDevice,
                    video: {
                      deviceId: e.target.value,
                    },
                  })
                }
                placeholder="없음"
                options={deviceList
                  ?.filter((device) => {
                    return device.kind === "videoinput";
                  })
                  .map((device) => {
                    return {
                      label: device.label,
                      value: device.deviceId,
                    };
                  })}
              />
            </div>

            <div className="mic-select">
              <p className="select-title mic-title">마이크 장치 선택</p>
              <Select
                value={
                  deviceList.filter((device) => {
                    return (
                      device.deviceId === selectedDevice.audio.deviceId &&
                      device.kind === "audioinput"
                    );
                  }).length !== 0
                    ? selectedDevice.audio.deviceId
                    : ""
                }
                onChange={(e) =>
                  setSelectedDevice({
                    ...selectedDevice,
                    audio: {
                      deviceId: e.target.value,
                    },
                  })
                }
                placeholder="없음"
                options={deviceList
                  ?.filter((device) => {
                    return device.kind === "audioinput";
                  })
                  .map((device) => {
                    return {
                      label: device.label,
                      value: device.deviceId,
                    };
                  })}
              />
            </div>

            <div className="speaker-test">
              <audio src="/media/audio.wav" ref={audioRef} />
              <p className="select-title speaker-title">스피커 테스트</p>
              <button
                className="test-sound-playbtn"
                onClick={() => audioRef.current.play()}
              >
                테스트 소리 재생
              </button>
            </div>
            <p className="device-select-step">
              장치 선택은 크롬 오른쪽 상단
              <br />
              '설정' → '개인정보 및 보안' → '사이트 설정' →'카메라', '마이크'
              <br />
              에서 하세요.
              <br />
              *장치 목록이 없을 경우 새로고침 해주세요.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeviceSelectModal;
